import script from "./rated-topics.vue?vue&type=script&setup=true&lang=js"
export * from "./rated-topics.vue?vue&type=script&setup=true&lang=js"

import "./rated-topics.vue?vue&type=style&index=0&id=1e5d6f3a&lang=scss"

const __exports__ = script;

export default __exports__